import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Modal from 'react-modal';
import { compose } from 'redux';
import Select from '4all-ui/components/Select';
import * as styles from './style';
import CreateMenuHelper from './CreateMenuHelper';
import Storage from '../../helpers/storage';
import Helper from '../../helpers/Helper';
import IconClose from '../../images/icon-close.svg';
import SelectableTagList from '../SelectableTagList';
import {
  UHUU_MKTPC_ID,
  SELECT_SERVICES_LIST,
  NEW_MENU_STORAGE_KEY,
  customModalStyles,
  PATHS,
} from '../../helpers/constants';
import { withMenus } from '../../containers/Menus';
import withMerchant from '../../containers/Merchant';
import withMenuModals from '../../containers/Modals/menu';
import { GroupInfo } from '../../styles/customComponents';
import withProducts from '../../containers/Products';
import { getParentSelector } from '../../helpers/modal';

class CreateMenuModal extends Component {
  state = {
    serviceTypes: null,
    marketplaces: [],
    mktpcHovered: null,
  };

  componentDidUpdate(prevProps) {
    const { merchant, modal } = this.props;
    const mktpcs = !merchant.marketplaces ? [] : merchant.marketplaces;
    const { menu } = modal;
    const { marketplaces } = this.state;

    if (
      marketplaces.length !== mktpcs.length &&
      JSON.stringify(marketplaces) !== JSON.stringify(mktpcs)
    ) {
      this.setState({
        marketplaces: merchant.marketplaces,
      });
    }

    if (Object.keys(menu).length && JSON.stringify(menu) !== JSON.stringify(prevProps.modal.menu)) {
      this.setState({
        serviceTypes: this.getSelectedServiceTypes(menu),
        marketplaces: merchant.marketplaces.map(mktpc => ({
          ...mktpc,
          active: menu.marketplaces.some(menuMktpc => menuMktpc === mktpc.id),
        })),
      });
    }
  }

  onChangeType = value => {
    this.setState(
      {
        serviceTypes: value,
      },
      () => {
        this.selectMarketplaces();
      }
    );
  };

  formatLabelValue = (currOption, options) => {
    const currPosition = options.findIndex(opt => opt.value === currOption.value);
    if (currOption.value === 'delivery') {
      return (
        <Fragment>
          {currPosition > 0 && <styles.CustomLabelSeparator>/</styles.CustomLabelSeparator>}
          <styles.CustomLabel>{currOption.label}</styles.CustomLabel>
        </Fragment>
      );
    }
    return (
      <Fragment>
        {currPosition >= 1 && <styles.CustomLabelSeparator>/</styles.CustomLabelSeparator>}
        <styles.CustomLabel>{currOption.label}</styles.CustomLabel>
      </Fragment>
    );
  };

  serializeMktpcs = () => {
    let serializedMarketplaces = [];
    const { menus, modal } = this.props;
    const { marketplaces, serviceTypes } = this.state;
    const newServiceTypes = serviceTypes ? serviceTypes.map(type => type.value) : [];

    if (marketplaces.length) {
      serializedMarketplaces = Helper.serializeMarketplaces(
        Helper.filterPossibleMarketplaces({
          marketplaces,
          menus,
          serviceTypes: newServiceTypes,
          editMenu: modal.menu,
        })
      );
      serializedMarketplaces = serializedMarketplaces.filter(mktpc => mktpc.id !== UHUU_MKTPC_ID);
    }

    return serializedMarketplaces;
  };

  getSelectedServiceTypes = menu => {
    const serviceTypes = [];

    SELECT_SERVICES_LIST.forEach(type => {
      type.options.forEach(option => {
        if (menu[option.value]) {
          serviceTypes.push(option);
        }
      });
    });

    return serviceTypes;
  };

  selectMarketplaces = (value = {}) => {
    const { menus, modal } = this.props;
    const { marketplaces, serviceTypes } = this.state;

    const newServiceTypes = serviceTypes ? serviceTypes.map(service => service.value) : [];
    const filteredMktps = Helper.filterPossibleMarketplaces({
      marketplaces,
      menus,
      serviceTypes: newServiceTypes,
      editMenu: modal.menu,
    });

    this.setState({
      marketplaces: marketplaces.map(mktpc => {
        return mktpc.id === value.id
          ? {
              ...mktpc,
              active: filteredMktps.find(fmktpc => fmktpc.id === mktpc.id).disabled
                ? false
                : !mktpc.active,
            }
          : {
              ...mktpc,
              active: filteredMktps.find(fmktpc => fmktpc.id === mktpc.id).disabled
                ? false
                : !!mktpc.active,
            };
      }),
    });
  };

  onHoverTag = mktpc => {
    if (this.serializeMktpcs().find(mkt => mkt.id === mktpc.id).disabled) {
      const { marketplaces } = this.state;

      this.setState({
        mktpcHovered: marketplaces.find(marketplace => marketplace.id === mktpc.id),
      });
    }
  };

  onBlurTag = () => {
    this.setState({ mktpcHovered: null });
  };

  onClose = () => {
    const { merchant, closeModal } = this.props;

    this.setState({
      serviceTypes: null,
      marketplaces: merchant.marketplaces,
    });

    closeModal();
  };

  goToUhuu = () => {
    const { merchant } = this.props;

    this.onClose();
    Storage.setLocalStorage(
      NEW_MENU_STORAGE_KEY,
      {
        marketplaces: merchant.marketplaces.filter(mtkpc => mtkpc.id === UHUU_MKTPC_ID),
      },
      1000000
    );
  };

  duplicateCheckedProducts = items => {
    for (const key in items.products) {
      const item = items.products[key];

      return {
        ...items,
        ...items.products,
        checked: item.checked,
      };
    }
  };

  onProceed = () => {
    const { categories, modal, history } = this.props;
    const { id } = modal.menu;
    const { showDuplicateMenuModal, showEditMenuModal } = modal;
    const { marketplaces, serviceTypes } = this.state;
    const menu = {
      id,
      title: modal.menu.name,
      published: modal.menu.published,
      marketplaces: marketplaces.filter(mktpc => mktpc.active),
      serviceTypes,
      salesDateBegin: modal.menu.salesDateBegin || null,
      salesDateEnd: modal.menu.salesDateEnd || null,
      salesDaysOfWeek: modal.menu.salesDaysOfWeek || null,
      categories: showDuplicateMenuModal
        ? modal.menu.categories.map(category => this.duplicateCheckedProducts(category))
        : showEditMenuModal
        ? categories.map(cat => ({
            ...cat,
            products: cat.products.map(prod => {
              let product = null;
              modal.menu.categories.forEach(categ => {
                if (categ.id === cat.id) {
                  product = categ.products.find(p => p.id === prod.id);
                  return;
                }
              });

              return {
                ...prod,
                checked: !!product,
                salesPrice: product ? product.salesPrice : null,
                salesDescription: product ? product.salesDescription : null,
                price: product ? product.price : prod.price,
              };
            }),
          }))
        : null,
    };

    Storage.setLocalStorage(NEW_MENU_STORAGE_KEY, menu, 1000000);
    this.onClose();
    history.push(PATHS.selectProducts);
  };

  hasMktpcUhuu = () => {
    const { merchant } = this.props;
    return merchant.marketplaces
      ? merchant.marketplaces.some(mktpc => mktpc.id === UHUU_MKTPC_ID)
      : false;
  };

  render() {
    const { menus, merchant } = this.props;
    const { showCreateMenuModal, showDuplicateMenuModal, showEditMenuModal } = this.props.modal;
    const { serviceTypes, marketplaces, mktpcHovered } = this.state;

    return (
      <Modal
        ariaHideApp={false}
        isOpen={showCreateMenuModal || showDuplicateMenuModal || showEditMenuModal}
        onRequestClose={this.onClose}
        style={customModalStyles}
        parentSelector={getParentSelector}
      >
        <styles.Container>
          <styles.CloseButton id="btn-close-create-menu-modal" onClick={this.onClose}>
            <styles.CloseIcon src={IconClose} />
          </styles.CloseButton>
          <styles.LeftInfo>
            <styles.Content>
              <styles.Header>
                <styles.Title>Criar Cardápio</styles.Title>
                {this.hasMktpcUhuu() && (
                  <styles.UhuuClient
                    id="btn-create-menu-uhuu"
                    to="/admin/menu/create_menu_uhuu"
                    onClick={this.goToUhuu}
                  >
                    Cliente Uhuu
                  </styles.UhuuClient>
                )}
              </styles.Header>
              <styles.Form>
                <GroupInfo styles={{ marginBottom: '35px' }}>
                  <label>Tipo de cardápio</label>
                  <p>Marque as opções desejadas para servir ou entregar seus pedidos.</p>
                  <Select
                    id="dropdown-service-types"
                    value={serviceTypes}
                    onChange={this.onChangeType}
                    options={Helper.serializeServiceTypes(SELECT_SERVICES_LIST, merchant)}
                    valueBgColor="transparent"
                    canRemove={false}
                    isMultiple
                    formatLabel={this.formatLabelValue}
                  />
                </GroupInfo>
                <GroupInfo>
                  <label>Marketplaces</label>
                  <p>Marque as opções disponíveis para seu tipo de cardápio.</p>
                  <SelectableTagList
                    tags={this.serializeMktpcs()}
                    selectTag={this.selectMarketplaces}
                    onHoverTag={this.onHoverTag}
                    onBlurTag={this.onBlurTag}
                  />
                </GroupInfo>
              </styles.Form>
            </styles.Content>
          </styles.LeftInfo>
          <styles.RightInfo>
            <CreateMenuHelper
              menus={menus}
              marketplaces={marketplaces}
              step={serviceTypes || marketplaces.some(m => m.active) ? 1 : 0}
              serviceTypes={serviceTypes || []}
              mktpcHovered={mktpcHovered}
              onConfirm={this.onProceed}
            />
          </styles.RightInfo>
        </styles.Container>
      </Modal>
    );
  }
}

CreateMenuModal.propTypes = {
  menus: PropTypes.array,
  merchant: PropTypes.object,
};

CreateMenuModal.defaultProps = {
  menus: [],
  merchant: {},
};

const CreateMenuComponent = compose(
  withRouter,
  withMenus,
  withMerchant,
  withMenuModals,
  withProducts
)(CreateMenuModal);

export default CreateMenuComponent;



// WEBPACK FOOTER //
// ./src/components/CreateMenuModal/index.js